"use client"

import { Moon, Sun } from "lucide-react"
import { useTheme } from "./ThemeProvider"
import { usePathname } from "next/navigation"

export function ThemeToggleFloat() {
  const { theme, setTheme, mounted } = useTheme()
  const pathname = usePathname()

  // Hide on public routes — theme toggle is in the public AppHeader instead
  const isAdmin = /^\/[a-z]{2}\/admin(\/|$)/.test(pathname)
  if (!isAdmin) return null

  const toggleTheme = () => {
    if (theme === "dark") {
      setTheme("light")
    } else {
      setTheme("dark")
    }
  }

  // Don't render anything until mounted to prevent hydration mismatch
  if (!mounted) {
    return (
      <div className="fixed bottom-4 right-4 z-50">
        <button
          className="p-2.5 rounded-full bg-background border border-border shadow-md opacity-50"
          aria-label="Loading theme"
          disabled
        >
          <div className="h-5 w-5" />
        </button>
      </div>
    )
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button
        onClick={toggleTheme}
        className="p-2.5 rounded-full bg-background border border-border shadow-md hover:shadow-lg transition-shadow"
        aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      >
        {theme === "dark" ? (
          <Sun className="h-5 w-5 text-foreground" />
        ) : (
          <Moon className="h-5 w-5 text-foreground" />
        )}
      </button>
    </div>
  )
}
